module.exports = __webpack_public_path__ + "static/media/Poweredby.7f3d166d.svg";